import i18n from "../i18n";
import RegisterUtils from "./RegisterUtils";

const RouteUtils = {
  registerPathAwareRoute(location, to) {
    if (location.pathname.startsWith('/map')) {
      return '/map/f/r' + to;
    }
    return '/register' + to;
  },
  navigateToObject(navigate, objectType, objectId) {
    switch (objectType) {
      case 'workOrder':
        navigate(`/workOrder/view/${objectId}`);
        break;
      case 'application':
      case 'clause':
        navigate(`/application/redirect/${objectId}`);
        break;
      case 'planning':
        navigate(`/plan/view/${objectId}`);
        break;
      default:
        const objectDef = RegisterUtils.getObjectDef(objectType);
        if (objectDef) {
          navigate(`/register/view/${objectType}/${objectId}`);
        }
    }
  },
  navigateToMap(navigate, objectType, objectId) {
    switch (objectType) {
      case 'workOrder':
        navigate(`/workOrder/view/${objectId}`);
        break;
      case 'application':
      case 'clause':
        navigate(`/application/redirect/${objectId}`);
        break;
      case 'planning':
        navigate(`/plan/view/${objectId}`);
        break;
      default:
        const objectDef = RegisterUtils.getObjectDef(objectType);
        if (objectDef) {
          navigate(`/map/f/r/viewCenter/${objectType}/${objectId}`);
        }
    }
  },
  setDocumentTitle(page) {
    if (i18n.isInitialized) {
      document.title = i18n.t('header.documentTitle', { page: i18n.t(`${page}.title`) });
    }
  }
};
export default RouteUtils;